import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from '../../healtheraComponents'

const DataGroup = ({ title, rows }) => (
  <>
    <Header>{title}</Header>
    <ListWrapper>
      {rows.map(({ label, value, key }) => (
        <ListItem key={key}>
          <Label>{label}</Label>
          <Value>{value}</Value>
        </ListItem>
      ))}
    </ListWrapper>
  </>
)

DataGroup.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
}

export default DataGroup

export const Header = styled.h3`
  color: ${colors.GRAY};
  font-size: 19px;
  margin: 14px 0;
`

export const ListWrapper = styled.ul`
  color: ${colors.GRAY};
  list-style-type: none;
  margin: 0;
  padding-left: 0;

  &:not(:last-child) {
    margin-bottom: 7px;
  }
`

export const ListItem = styled.li`
  color: ${colors.GRAY_DARKER};
  display: flex;
  font-size: 17px;
  margin-top: 7px;
`

export const Label = styled.div`
  flex: 0 0 70px;
  font-weight: 600;

  &:empty {
    display: none;
  }
`

export const Value = styled.div`
  word-break: break-word;
`
